import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
	selector: 'app-flora-intestinal',
	templateUrl: 'flora-intestinal.component.html'
})
export class FloraIntestinalComponent implements OnInit {
  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Por qué debes cuidar tu flora intestinal? | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"¿Por qué debes cuidar tu flora intestinal? | Sinuberase",
  		description: "Sinuberase contiene probióticos que, al restaurar la flora intestinal, ayudan a prevenir problemas como infecciones intestinales y efectos secundarios de antibióticos",
  		slug: "Flora-intestinal"
  	})

		this.seo.closeMenu();
	}
}